import { notification } from 'antd'
import axios from './axiosInstance'
import constants from '../constants'
import { isAuthenticated } from '../utils/authSession'
import { handleErrors, definedErrorCodes } from '../helpers'

export default function init() {
  console.log('subscriptions init')
}

export async function subscribe(post, app) {
  if (isAuthenticated()) {
    const ACTION_URL = constants.customerDomain
    return axios
      .post(`${ACTION_URL}apps/${app.id}/subscriptions`, post)
      .then(res => {
        return res.data
      })
      .catch(error => {
        let errorMsgs = handleErrors('')
        if (
          error.response &&
          error.response.data.error.code !== undefined &&
          definedErrorCodes(error.response.data.error.code)
        ) {
          errorMsgs = handleErrors(error.response.data.error.code)
          notification.warning({
            message: errorMsgs.message,
            description: errorMsgs.description,
          })
        }
        return error
      })
  }
  return false
}

export async function unsubscribe(app, userDataObj = false) {
  if (isAuthenticated()) {
    const ACTION_URL = constants.customerDomain
    return axios
      .delete(`${ACTION_URL}apps/${app.id}/subscriptions`)
      .then(res => {
        if (userDataObj && userDataObj !== '') {
          localStorage.setItem('userData', userDataObj)
        }
        return res.data
      })
      .catch(error => {
        let errorMsgs = handleErrors('')
        if (
          error.response &&
          error.response.data.error.code !== undefined &&
          definedErrorCodes(error.response.data.error.code)
        ) {
          errorMsgs = handleErrors(error.response.data.error.code)
          notification.warning({
            message: errorMsgs.message,
            description: errorMsgs.description,
          })
        }
        return error.response.data
      })
  }
  return false
}

export async function stripeCall1(post, app) {
  if (isAuthenticated()) {
    const ACTION_URL = constants.customerDomain
    return axios
      .post(`${ACTION_URL}apps/${app.id}/subscriptions`, post)
      .then(res => {
        return res.data
      })
      .catch(error => {
        let errorMsgs = handleErrors('')
        if (
          error.response &&
          error.response.data.error.code !== undefined &&
          definedErrorCodes(error.response.data.error.code)
        ) {
          errorMsgs = handleErrors(error.response.data.error.code)
          notification.warning({
            message: errorMsgs.message,
            description: errorMsgs.description,
          })
        }
        return error.response.data
      })
  }
  return false
}

export async function stripeCall2(post, app, userDataObj = false) {
  if (isAuthenticated()) {
    const ACTION_URL = constants.customerDomain
    return axios
      .post(`${ACTION_URL}apps/${app.id}/subscriptions`, post)
      .then(res => {
        if (userDataObj && userDataObj !== '') {
          localStorage.setItem('userData', userDataObj)
        }
        return res.data
      })
      .catch(error => {
        let errorMsgs = handleErrors('')
        if (
          error.response &&
          error.response.data.error.code !== undefined &&
          definedErrorCodes(error.response.data.error.code)
        ) {
          errorMsgs = handleErrors(error.response.data.error.code)
          notification.warning({
            message: errorMsgs.message,
            description: errorMsgs.description,
          })
        }
        return error.response.data
      })
  }
  return false
}
